module.exports = __webpack_public_path__ + "img/UAE-landscape-arabic.c36e4462.png";